module.exports = __webpack_public_path__ + "img/pi-1-5.bb25bf4c.jpg";